<div class="ppl-mt8">
  <h2 tabindex="-1" pplAutoFocusHeader>Summary</h2>
  <p class="ppl-description">Please review the details on this summary page. If any updates are needed, return to the
    respective sections to make adjustments.
  </p>
</div>
<div class="ppl-mt16 btn-group" style="display: flex; gap: 8px;">
  <!-- <button nzType="primary" class="ppl-mr16 btn-hide" nz-button [nzSize]="'small'" (click)="expandAll()">Expand
    All</button>
  <button nzType="primary" nz-button class="btn-hide" [nzSize]="'small'" (click)="hideAll()">Hide All</button> -->
  <ppl-button label="Expand All" icon="fa fa-expand" [customClass]="'alt-button'" [iconPosition]="'right'"
    (click)="expandAll()"></ppl-button>
  <ppl-button label="Collapse All" icon="fa fa-compress" [customClass]="'alt-button'" [iconPosition]="'right'"
    (click)="hideAll()"></ppl-button>
</div>
<div>
  <!-- <div class="expand-collapse-container"> -->
  <div class="infoBox" style="margin-top: 0.8rem;">
    <i class="fa fa-info-circle" aria-hidden="true"></i> Your form will be processed by our team and we will contact you
    directly if we have any further questions.
  </div>
  <!-- </div> -->
  <nz-collapse [nzExpandIconPosition]="'end'">
    @if(getSteps('participant_info')?.isAvailable === "Y"){
    <nz-collapse-panel [nzHeader]="participantInfoHeader" [nzActive]="isPanelActive('1')"
      (nzClick)="togglePanel($event, '1')">
      <ng-template #participantInfoHeader>
        <button type="button" tabindex="0" class="collapse-header-button" (click)="togglePanel($event, '1')"
          (keydown.enter)="togglePanel($event, '1')" (keydown.space)="togglePanel($event, '1')"
          [attr.aria-expanded]="isPanelActive('1')">
          {{getSteps('participant_info')?.step_name}}
        </button>
      </ng-template>
      <ppl-participant-info [mode]="'read'"></ppl-participant-info>
    </nz-collapse-panel>
    }
    @if(getSteps('service_details')?.isAvailable === "Y"){
    <nz-collapse-panel [nzHeader]="serviceDetailsHeader" [nzActive]="isPanelActive('2')"
      (nzClick)="togglePanel($event, '2')">
      <ng-template #serviceDetailsHeader>
        <button type="button" tabindex="0" class="collapse-header-button" (click)="togglePanel($event, '2')"
          (keydown.enter)="togglePanel($event, '2')" (keydown.space)="togglePanel($event, '2')"
          [attr.aria-expanded]="isPanelActive('2')">
          {{getSteps('service_details')?.step_name}}
        </button>
      </ng-template>
      <ppl-service-details [mode]="'read'"></ppl-service-details>
    </nz-collapse-panel>
    }
    @if(getSteps('contact_details')?.isAvailable === "Y"){
    <nz-collapse-panel [nzHeader]="contactDetailsHeader" [nzActive]="isPanelActive('3')"
      (nzClick)="togglePanel($event, '3')">
      <ng-template #contactDetailsHeader>
        <button type="button" tabindex="0" class="collapse-header-button" (click)="togglePanel($event, '3')"
          (keydown.enter)="togglePanel($event, '3')" (keydown.space)="togglePanel($event, '3')"
          [attr.aria-expanded]="isPanelActive('3')">
          {{getSteps('contact_details')?.step_name}}
        </button>
      </ng-template>
      <ppl-contact-details [mode]="'read'"></ppl-contact-details>
    </nz-collapse-panel>
    }
    @if(getSteps('comm_preferences')?.isAvailable === "Y"){
    <nz-collapse-panel [nzHeader]="commPreferenceHeader" [nzActive]="isPanelActive('4')"
      (nzClick)="togglePanel($event, '4')">
      <ng-template #commPreferenceHeader>
        <button type="button" tabindex="0" class="collapse-header-button" (click)="togglePanel($event, '4')"
          (keydown.enter)="togglePanel($event, '4')" (keydown.space)="togglePanel($event, '4')"
          [attr.aria-expanded]="isPanelActive('4')">
          {{getSteps('comm_preferences')?.step_name}}
        </button>
      </ng-template>
      <ppl-comm-preference [mode]="'read'"></ppl-comm-preference>
    </nz-collapse-panel>
    }
    @if(getSteps('associations')?.isAvailable === "Y"){
    <nz-collapse-panel [nzHeader]="newContactHeader" [nzActive]="isPanelActive('5')"
      (nzClick)="togglePanel($event, '5')">
      <ng-template #newContactHeader>
        <button type="button" tabindex="0" class="collapse-header-button" (click)="togglePanel($event, '5')"
          (keydown.enter)="togglePanel($event, '5')" (keydown.space)="togglePanel($event, '5')"
          [attr.aria-expanded]="isPanelActive('5')">
          {{getSteps('associations')?.step_name}}
        </button>
      </ng-template>
      <ppl-new-contact [mode]="'read'"></ppl-new-contact>
    </nz-collapse-panel>
    }
    @if(getSteps('signatures')?.isAvailable === "Y"){
    <nz-collapse-panel [nzHeader]="uploadSignaturesHeader" [nzActive]="isPanelActive('6')"
      (nzClick)="togglePanel($event, '6')">
      <ng-template #uploadSignaturesHeader>
        <button type="button" tabindex="0" class="collapse-header-button" (click)="togglePanel($event, '6')"
          (keydown.enter)="togglePanel($event, '6')" (keydown.space)="togglePanel($event, '6')"
          [attr.aria-expanded]="isPanelActive('6')">
          {{getSteps('signatures')?.step_name}}
        </button>
      </ng-template>
      <ppl-upload-signatures *ngIf="isPanelActive('6')" [mode]="'read'"></ppl-upload-signatures>
    </nz-collapse-panel>
    }
    @if(getSteps('forms')?.isAvailable === "Y"){
    <nz-collapse-panel [nzHeader]="formChecklistHeader" [nzActive]="isPanelActive('7')"
      (nzClick)="togglePanel($event, '7')">
      <ng-template #formChecklistHeader>
        <button type="button" tabindex="0" class="collapse-header-button" (click)="togglePanel($event, '7')"
          (keydown.enter)="togglePanel($event, '7')" (keydown.space)="togglePanel($event, '7')"
          [attr.aria-expanded]="isPanelActive('7')">
          {{getSteps('forms')?.step_name}}
        </button>
      </ng-template>
      <ppl-form-checklist *ngIf="isPanelActive('7')" [mode]="'read'"></ppl-form-checklist>
    </nz-collapse-panel>
    }
    @if(getSteps('checklist')?.isAvailable === "Y"){
    <nz-collapse-panel [nzHeader]="participantChecklistHeader" [nzActive]="isPanelActive('8')"
      (nzClick)="togglePanel($event, '8')">
      <ng-template #participantChecklistHeader>
        <button type="button" tabindex="0" class="collapse-header-button" (click)="togglePanel($event, '8')"
          (keydown.enter)="togglePanel($event, '8')" (keydown.space)="togglePanel($event, '8')"
          [attr.aria-expanded]="isPanelActive('8')">
          {{getSteps('checklist')?.step_name}}
        </button>
      </ng-template>
      <ppl-participant-checklist></ppl-participant-checklist>
    </nz-collapse-panel>
    }
    @if(getSteps('upload_docs')?.isAvailable === "Y"){
    <nz-collapse-panel [nzHeader]="uploadDocsHeader" [nzActive]="isPanelActive('9')"
      (nzClick)="togglePanel($event, '9')">
      <ng-template #uploadDocsHeader>
        <button type="button" tabindex="0" class="collapse-header-button" (click)="togglePanel($event, '9')"
          (keydown.enter)="togglePanel($event, '9')" (keydown.space)="togglePanel($event, '9')"
          [attr.aria-expanded]="isPanelActive('9')">
          {{getSteps('upload_docs')?.step_name}}
        </button>
      </ng-template>
      <ppl-upload-docs [mode]="'read'"></ppl-upload-docs>
    </nz-collapse-panel>
    }
    @if(getSteps('payment_details')?.isAvailable === "Y"){
    <nz-collapse-panel [nzHeader]="paymentDetailsHeader" [nzActive]="isPanelActive('10')"
      (nzClick)="togglePanel($event, '10')">
      <ng-template #paymentDetailsHeader>
        <button type="button" tabindex="0" class="collapse-header-button" (click)="togglePanel($event, '10')"
          (keydown.enter)="togglePanel($event, '10')" (keydown.space)="togglePanel($event, '10')"
          [attr.aria-expanded]="isPanelActive('10')">
          {{getSteps('payment_details')?.step_name}}
        </button>
      </ng-template>
      <ppl-payment-details [mode]="'read'"></ppl-payment-details>
    </nz-collapse-panel>
    }
  </nz-collapse>
</div>